import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaIconSharedModule } from '../../atoms/fa.icon/fa.icon.module';
import { TileSharedComponent } from './tile.component';

@NgModule({
    declarations: [
        TileSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        TileSharedComponent
    ]
})

export class TileSharedModule {}
